
export   const products = [
    { 
      id: 166, 
      name: 'LED Spot Light', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs<br>• Available Watts : 5W , 7W', 
      imageUrls: ['../Assets/Spotlight/Spotlightfront.jpg', '../Assets/Spotlight/Spotlightback.jpg', '../Assets/Spotlight/Spotlightpacket.jpg'] 
    },
    { 
      id: 167, 
      name: 'LED Spot Light RGB', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs<br>• Available Watts : 5W , 7W', 
      imageUrls: ['../Assets/Spotlight/Spotlightrgbfront.jpg', '../Assets/Spotlight/Spotlightrgbback.jpg', '../Assets/Spotlight/Spotlightrgbpacket.jpg'] 
    },
  
  
  ];
    
    export default {
        products,
    }
  